import { render, staticRenderFns } from "./FullImage.vue?vue&type=template&id=262d772e&scoped=true&"
import script from "./FullImage.vue?vue&type=script&lang=js&"
export * from "./FullImage.vue?vue&type=script&lang=js&"
import style0 from "./FullImage.vue?vue&type=style&index=0&id=262d772e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262d772e",
  null
  
)

export default component.exports